export enum OnlineQtInitQueryParametersEnum {
  Locale = 'locale',
}
